import { DEFAULT_CSS_CLASS } from '@constants';
import { devices } from '@helpers/utils.js';
import { ImageAsBackgroundSaveBlock } from '../index';

const ImageAsBackgroundSave = ({ imageAsBackgroundOptions }) => {
  const classNames = `${DEFAULT_CSS_CLASS.BG_IMAGE_CONTAINER}`;
  return (
    <ImageAsBackgroundSaveBlock
      {...{ classNames, devices, imageAsBackgroundOptions }}
    />
  );
};

export default ImageAsBackgroundSave;
